/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.form-select {
  position: relative;
}
.show-in-form {
  position: relative;
  margin-top: calc(var(--spacing, 0.25rem) * 5);
}
.show-in-form .labelText {
  position: absolute;
  top: -18px;
}
.searchable {
  margin: calc(var(--spacing, 0.25rem) * 4);
}
.searchable input {
  background-color: var(--color-gray-100, #f5f5f5);
  --tw-border-style: none;
  border-style: none;
}
.labelText {
  color: var(--color-emphasis-extra, var(--color-primary-500));
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-gray-500, #737373);
  white-space: nowrap;
}
.labelText.focus {
  color: var(--color-emphasis-extra, var(--color-primary-500));
}
button.hasError, div[role="combobox"].hasError {
  border-color: var(--color-red-700, oklch(50.5% 0.213 27.518));
}
.error-text {
  color: var(--color-red-700, oklch(50.5% 0.213 27.518));
  font-style: italic;
}
.error {
  color: var(--color-red-700, oklch(50.5% 0.213 27.518));
  margin-top: var(--spacing, 0.25rem);
}
.dropdown-button {
  cursor: pointer;
  background-color: var(--color-white, #fff);
  border-color: var(--color-gray-300, #d4d4d4);
  --tw-border-style: solid;
  border-style: solid;
  border-style: var(--tw-border-style);
  border-width: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: var(--radius-sm, 0.25rem);
  padding: calc(var(--spacing, 0.25rem) * 3);
  font-size: max(var(--text-sm), 1em);
  white-space: nowrap;
  height: calc(var(--spacing, 0.25rem) * 10);
}
.position-above {
  bottom: calc(44px + 0.25em);
}
.dropdown-button:disabled {
  opacity: 30%;
}
.dropdown-button:focus {
  border-color: var(--color-primary-500);
}
.dropdown-button > svg {
  margin-left: calc(var(--spacing, 0.25rem) * 2);
  color: var(--color-primary-500);
}
.dropdown-list {
  position: absolute;
  border-color: var(--color-gray-300, #d4d4d4);
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  margin: 0px;
  padding: 0px;
  background-color: var(--color-white, #fff);
  border-radius: var(--radius-sm, 0.25rem);
  font-size: max(var(--text-sm), 1em);
  z-index: 500;
  max-height: calc(var(--spacing, 0.25rem) * 96);
  overflow: auto;
}
.dropdown-list > li > label {
  padding-inline: 1.5em;
  padding-block: 0.75em;
}
.dropdown-list > li:first-of-type {
  margin-top: calc(var(--spacing, 0.25rem) * 3);
}
.dropdown-list > li:last-of-type {
  margin-bottom: calc(var(--spacing, 0.25rem) * 3);
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
    }
  }
}
